import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { InAppTemplate } from "../../../shared/templates/inapp";

import { TableComponent } from "../../../shared/components/table";

import { Formik, Form, Field, FormikProps, ErrorMessage } from "formik";
import * as Yup from "yup";

import { getDateFromISO, formatPhoneNumber } from "../../../shared/utils";

import { AlertMsg } from "../../../shared/components/alert-msg";

import { LoadingItem } from "../../../shared/components/loading";
import DownloadIco from "../../../assets/download.svg";
import BackIco from "../../../assets/back.svg";
import SuspendIco from "../../../assets/icons/suspend.svg";
import ShopIco from "../../../assets/shop_ico.svg";

import Total_Sales from "../../../assets/icons/stores/total_sales.svg";
import Total_Orders from "../../../assets/icons/stores/total_orders.svg";
import Products from "../../../assets/icons/stores/products.svg";
import People from "../../../assets/icons/stores/people.svg";

import Cherry from "../../../assets/icons/stores/best-sellers/cherry.jpg";
import Lemon from "../../../assets/icons/stores/best-sellers/lemon_squeezy.jpg";
import Cashew from "../../../assets/icons/stores/best-sellers/medium_size_cashew_juice.jpg";
import Orange from "../../../assets/icons/stores/best-sellers/orange_bag_pack.jpg";
import Pineapple from "../../../assets/icons/stores/best-sellers/pineapple_fresh_farm.jpg";

import { appActions } from "../../../redux/actions/in-app";
import { appConstants } from "../../../redux/action-constants/inapp.constants";

import { history } from "../../../shared/_helpers/history";

import TrendUp from "../../../assets/trend_up.svg";
import { useWindowSize } from "../../../hooks/useWindowSize";

import "../index.scss";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  ArcElement,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import { Line, Doughnut } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  ArcElement,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

const getStoreDetails = async ({ pageProps, payload }: any) => {
  await pageProps.getStoreDetailsAction(payload);
};
const getAStoreChartAction = async ({ pageProps, payload }: any) => {
  await pageProps.getAStoreChartData(payload);
};

const getStoreTransactions = async ({ pageProps, payload }: any) => {
  await pageProps.getStoreTransactionsAction(payload);
};

const toggleStoreAction = async ({ pageProps, payload, action }: any) => {
  await pageProps.toggleStoreAction(payload, action);
};

const SuspendStoreModal = (props: any) => {
  let { showSuspendModal, setShowSuspendModal, pageProps, storeId, setActive } =
    props;

  let checkValidationSchema = Yup.object().shape({
    reason: Yup.string().trim().required("Required"),
  });

  const suspendProcess: any = (payload: any) => {
    toggleStoreAction({
      pageProps,
      payload,
      action: "suspend",
    }).then(() => {
      setActive(false);
    });
  };

  return (
    <Modal
      className="suspend_wrap"
      show={showSuspendModal}
      onHide={() => {
        if (!pageProps?.d?.is_request_processing) {
          setShowSuspendModal(false);
        }
      }}
    >
      <Modal.Header closeButton>Suspend store?</Modal.Header>
      <Modal.Body>
        {pageProps?.d?.request_status !== appConstants.TOGGLE_STORE_SUCCESS && (
          <>
            <div className="head_message">
              Please be advised that suspending this store will means that{" "}
              <span>
                {" "}
                customers will be unable to make purchases from this store
              </span>{" "}
              until the suspension is lifted. Are you sure you want to proceed
              with this action?
            </div>
            <div className="suspend_form">
              <Formik
                initialValues={{
                  reason: "",
                }}
                validationSchema={checkValidationSchema}
                onSubmit={(values) => {
                  let { reason } = values;
                  let payload = {
                    ids: [storeId],
                    reason,
                  };

                  suspendProcess(payload);
                }}
              >
                {(props: FormikProps<any>) => {
                  const {
                    values,
                    touched,
                    errors,
                    // handleBlur,
                    handleChange,
                    // isSubmitting,
                  } = props;

                  return (
                    <Form>
                      {!pageProps.d?.is_request_processing && (
                        <textarea
                          value={values.reason}
                          name="reason"
                          id="reason"
                          placeholder="Reason for suspension"
                          onChange={handleChange("reason")}
                          className={` ${
                            errors.reason && touched.reason
                              ? "is-invalid-input "
                              : !errors.reason && values.reason !== ""
                              ? "valid-input"
                              : ""
                          }`}
                          rows={10}
                        ></textarea>
                      )}
                      <ErrorMessage
                        name="reason"
                        className="form-input-error"
                        component="div"
                      />
                      {pageProps?.d?.request_status &&
                        pageProps.d.request_status ===
                          appConstants.TOGGLE_STORE_FAILURE && (
                          <AlertMsg
                            type="error"
                            message={pageProps.d?.request_data.error}
                          />
                        )}
                      <div className="suspend_ctas">
                        <button
                          className="btn cancel"
                          disabled={pageProps.d?.is_request_processing}
                          onClick={() => setShowSuspendModal(false)}
                        >
                          {" "}
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn confirm"
                          disabled={pageProps.d?.is_request_processing}
                        >
                          {pageProps.d.is_request_processing
                            ? "Please wait..."
                            : "Confirm suspension"}
                        </button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </>
        )}
        {pageProps?.d?.request_status === appConstants.TOGGLE_STORE_SUCCESS && (
          <AlertMsg type="success" message="Store was successfully suspended" />
        )}
      </Modal.Body>
    </Modal>
  );
};

const ActivateStoreModal = (props: any) => {
  let {
    showActivateModal,
    setShowActivateModal,
    pageProps,
    storeId,
    setActive,
  } = props;

  const activateProcess: any = () => {
    toggleStoreAction({
      pageProps,
      payload: { ids: [storeId] },
      action: "activate",
    }).then(() => {
      // Update the active state to true when activated
      setActive(true);
    });
  };

  return (
    <Modal
      className="activate_wrap"
      show={showActivateModal}
      onHide={() => {
        if (!pageProps?.d?.is_request_processing) {
          setShowActivateModal(false);
        }
      }}
    >
      <Modal.Header closeButton>Activate store?</Modal.Header>
      <Modal.Body>
        {pageProps?.d?.request_status !== appConstants.TOGGLE_STORE_SUCCESS && (
          <>
            <div className="head_message">
              Are you sure you want to activate this store? Once activated,{" "}
              <span>
                customers will be able to make purchases from this store
              </span>
              .
            </div>

            {pageProps?.d?.request_status &&
              pageProps.d.request_status ===
                appConstants.TOGGLE_STORE_FAILURE && (
                <AlertMsg
                  type="error"
                  message={pageProps.d?.request_data.error}
                />
              )}

            <div className="activate_ctas">
              <button
                className="btn cancel"
                disabled={pageProps.d?.is_request_processing}
                onClick={() => setShowActivateModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn confirm"
                disabled={pageProps.d?.is_request_processing}
                onClick={activateProcess}
              >
                {pageProps.d.is_request_processing
                  ? "Please wait..."
                  : "Confirm activation"}
              </button>
            </div>
          </>
        )}
        {pageProps?.d?.request_status === appConstants.TOGGLE_STORE_SUCCESS && (
          <AlertMsg type="success" message="Store was successfully activated" />
        )}
      </Modal.Body>
    </Modal>
  );
};

const AccountStatus = ({
  active,
  onSuspendClick,
  onActivateClick,
}: {
  active: boolean;
  onSuspendClick: () => void;
  onActivateClick: () => void;
}) => {
  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newStatus = e.target.value;

    if (newStatus === "Active" && !active) {
      // User wants to activate - show activate modal
      onActivateClick();
    } else if (newStatus === "Inactive" && active) {
      // User wants to suspend - show suspend modal
      onSuspendClick();
    }

    // Reset the dropdown to current status if no action taken
    // The actual state change will happen in the modal after confirmation
    e.target.value = active ? "Active" : "Inactive";
  };

  return (
    <div className="account-status-dropdown">
      <label>Account Status</label>
      <select
        value={active ? "Active" : "Inactive"}
        onChange={handleStatusChange}
        className="status-select"
      >
        <option value="Active">Active</option>
        <option value="Inactive">Inactive</option>
      </select>
    </div>
  );
};

const SalesChart = ({ salesData }: any) => {
  let chartValues: any[] = salesData.map((each: any) => each?.count);
  let chartLabels: any[] = salesData.map((each: any) => each?.grouping);
  const options = {
    responsive: true,
    cutout: 120,
    plugins: {
      legend: {
        display: false,
        position: "top" as const,
      },
      title: {
        display: false,
        // text: 'Chart.js Line Chart',
      },
    },
    tension: 0.5,
  };
  const data6 = {
    labels: chartLabels,
    datasets: [
      {
        label: "",
        data: chartValues,
        borderColor: "#00A85B",
        borderWidth: 2,
        // backgroundColor: 'rgba(255, 99, 132, 0.5)',
      },
      // {
      //     label: '',
      //     data: labelValues2,
      //     borderColor: 'rgb(80, 143, 244)',
      //     borderWidth: 5,
      //     // backgroundColor: 'rgba(255, 99, 132, 0.5)',
      // },
    ],
  };
  return (
    <>
      {salesData.length >= 1 && <Line options={options} data={data6} />}

      {salesData.length === 0 && (
        <div className="no-data">No Data for specified period</div>
      )}
    </>
  );
};

const StoreOwnerCard = ({ ownerData }: any) => {
  // Dummy data with default values
  const dummyOwnerData = {
    storeOwner: "John Doe",
    phoneNumber: "123-456-7890",
    email: "johndoe@example.com",
    address: "456 elm street",
  };

  const owner = ownerData || dummyOwnerData;

  return (
    <div className="store_owner_card">
      <div className="card_header">
        <h3 className="card_title">Store Owner Details</h3>
        <button className="edit_btn">Edit</button>
      </div>

      <div className="owner_details">
        <div className="detail_row">
          <div className="detail_left">
            <div className="detail_label">Name</div>
            <div className="detail_value">{owner.storeOwner}</div>
          </div>
          <div className="detail_right">
            <div className="detail_label">Contact number</div>
            <div className="detail_value">
              {formatPhoneNumber(owner.phoneNumber)}
            </div>
          </div>
        </div>

        <div className="detail_row">
          <div className="detail_full">
            <div className="detail_label">Email</div>
            <div className="detail_value">{owner.email}</div>
          </div>
        </div>

        <div className="detail_row">
          <div className="detail_full">
            <div className="detail_label">Address</div>
            <div className="detail_value">
              {owner.addressLine1 || "N/A"}
              <br />
              {/* {owner.address?.city || ""}, {owner.address?.province || ""}{" "}
              {owner.address?.postalCode || ""}, {owner.address?.country || ""} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const MetricsCards = ({ storeId }: { storeId: string }) => {
  const navigate = useNavigate();
  const metricsData = {
    totalSales: 33625.19,
    salesChange: "7%",
    totalOrders: 412,
    ordersChange: "13%",
    totalProducts: 254,
    productsChange: "5%",
    averageOrder: 23691,
    averageChange: "23%",
  };
  return (
    <div className="metrics_grid">
      <div className="metric_card">
        <div className="metric_content">
          <div className="metric_value">
            ${metricsData?.totalSales?.toLocaleString() || "33,625.19"}
          </div>
          <div className="metric_label">Total sales</div>
          <div className="metric_change positive">
            <span className="change_arrow">↗</span>
            <span className="change_percent">
              {metricsData?.salesChange || "7%"}
            </span>
            <span className="change_text">from last month</span>
          </div>
        </div>
        <div className="metric_icon green">
          <img src={Total_Sales} alt="" />
        </div>
      </div>

      <div className="metric_card">
        <div className="metric_content">
          <div className="metric_value">
            {metricsData?.totalOrders || "412"}
          </div>
          <div className="metric_label">Total orders</div>
          <div className="metric_change positive">
            <span className="change_arrow">↗</span>
            <span className="change_percent">
              {metricsData?.ordersChange || "13%"}
            </span>
            <span className="change_text">from last month</span>
          </div>
        </div>
        <div className="metric_icon orange">
          <img src={Total_Orders} alt="" />
        </div>
      </div>

      <div
        className="metric_card"
        onClick={() => navigate(`/app/stores/${storeId}/products`)}
        role="button"
        tabIndex={2}
      >
        <div className="metric_content">
          <div className="metric_value">
            {metricsData?.totalProducts || "254"}
          </div>
          <div className="metric_label">Products</div>
          <div className="metric_change positive">
            <span className="change_arrow">↗</span>
            <span className="change_percent">
              {metricsData?.productsChange || "5%"}
            </span>
            <span className="change_text">from last month</span>
          </div>
        </div>
        <div className="metric_icon gray">
          <img src={Products} alt="" />
        </div>
      </div>

      <div className="metric_card">
        <div className="metric_content">
          <div className="metric_value">
            {metricsData?.averageOrder?.toLocaleString() || "23,691"}
          </div>
          <div className="metric_label">Average order</div>
          <div className="metric_change negative">
            <span className="change_arrow">↙</span>
            <span className="change_percent">
              {metricsData?.averageChange || "23%"}
            </span>
            <span className="change_text">from last month</span>
          </div>
        </div>
        <div className="metric_icon blue">
          <img src={People} alt="" />
        </div>
      </div>
    </div>
  );
};

const BestSellers = () => {
  const bestSellersData = [
    {
      id: 1,
      name: "Medium Size Cashew Juice..",
      image: Cashew,
      orders: 20,
    },
    {
      id: 2,
      name: "Orange bag packs",
      image: Orange,
      orders: 20,
    },
    {
      id: 3,
      name: "Lemon squeezy",
      image: Lemon,
      orders: 20,
    },
    {
      id: 4,
      name: "Pineapple fresh farm",
      image: Pineapple,
      orders: 20,
    },
    {
      id: 5,
      name: "Cherry",
      image: Cherry,
      orders: 20,
    },
  ];

  const getProductIcon = (productName: string | undefined): string => {
    if (!productName) return People;

    const name = productName.toLowerCase();
    if (name.includes("juice") || name.includes("drink")) {
      return Total_Sales;
    } else if (name.includes("bag") || name.includes("pack")) {
      return Products;
    } else if (
      name.includes("fruit") ||
      name.includes("lemon") ||
      name.includes("cherry") ||
      name.includes("pineapple")
    ) {
      return Total_Orders;
    }
    return People; // Default fallback
  };

  return (
    <div className="best_sellers_list">
      {bestSellersData.map((item) => (
        <div key={item.id} className="best_seller_item">
          <div className="product_image">
            {item.image ? (
              <img src={item.image} alt={item.name} />
            ) : (
              <img src={getProductIcon(item.name)} alt="" />
            )}
          </div>
          <div className="product_details">
            <div className="product_info">
              <h4 className="product_name">{item.name}</h4>
            </div>
            <div className="order_count">{item.orders} Orders</div>
          </div>
        </div>
      ))}
    </div>
  );
};

const InAppContent = ({ pageProps }: any) => {
  const [salesFlag, setSalesFlag] = useState(1);
  const screenResolution: any = useWindowSize();
  const { storeId } = useParams();
  const { state } = useLocation();
  const [showSuspendModal, setShowSuspendModal] = useState<boolean>(false);
  const [active, setActive] = useState<boolean>(false);
  const [showActivateModal, setShowActivateModal] = useState(false);
  const [timeRange, setTimeRange] = useState<string>("30 Days");

  useEffect(() => {
    setActive(
      pageProps.getStoreDetailsRequest?.request_data?.response?.data
        ?.isActive ?? false
    );
  }, [pageProps]);

  const handleSuspendClick = () => {
    toggleStoreAction({
      pageProps,
      payload: "CLEAR",
      action: "suspend",
    });
    setShowSuspendModal(true);
  };

  const handleActivateClick = () => {
    toggleStoreAction({
      pageProps,
      payload: "CLEAR",
      action: "activate",
    });
    setShowActivateModal(true);
  };

  useEffect(() => {
    getStoreDetails({
      pageProps,
      payload: `?Id=${storeId}`,
    });

    getStoreTransactions({
      pageProps,
      payload: `?StoreId=${storeId}`,
    });

    let graphPayload = `StoreId=${storeId}&ReportGroupingType=${salesFlag}`;

    getAStoreChartAction({
      pageProps,
      payload: graphPayload,
    });
  }, []);

  const ReportTable = () => {
    let txtnList =
      pageProps.getStoreTransactionsRequest?.request_data?.response?.data;
    let alltxtnList: any[] = txtnList?.results;
    return (
      <>
        <thead>
          <tr>
            <th className="left_top">
              {" "}
              <span>Transaction date</span>{" "}
            </th>
            <th> Transaction ID</th>
            <th>Amount</th>
            {/* <th>Fee</th> */}
            <th>Status</th>
            {/* <th>Paid out</th> */}
            <th className="right_top">
              {" "}
              <span>Invoice</span>{" "}
            </th>
          </tr>
        </thead>
        <tbody>
          {alltxtnList.map((eachItem: any, index: any) => {
            return (
              <tr>
                <td>
                  {eachItem.createdDate
                    ? getDateFromISO({
                        date: eachItem.createdDate,
                        returnTime: true,
                      })
                    : "N/A"}
                </td>
                <td className="grayed">{eachItem.accountNumber}</td>
                <td className="grayed">${eachItem?.amount}</td>
                {/* <td className="grayed"> -</td> */}
                <td>
                  {" "}
                  <span className="order_status ongoing ">
                    {eachItem?.payoutStatus}
                  </span>
                </td>
                {/* <td className="branded">-</td> */}

                <td className="branded">
                  <span>
                    Download <img src={DownloadIco} alt="" />{" "}
                  </span>{" "}
                </td>
              </tr>
            );
          })}
        </tbody>
      </>
    );
  };

  const ReportsDisplay = () => {
    let storeDetails =
      pageProps.getStoreDetailsRequest?.request_data?.response?.data;

    // const [showSuspendModal, setShowSuspendModal] = useState<boolean>(false);

    return (
      <div className="reports_wrap">
        {showSuspendModal && (
          <SuspendStoreModal
            pageProps={pageProps}
            storeId={storeId}
            showSuspendModal={showSuspendModal}
            setShowSuspendModal={setShowSuspendModal}
            setActive={setActive}
          />
        )}

        {showActivateModal && (
          <ActivateStoreModal
            pageProps={pageProps}
            storeId={storeId}
            showActivateModal={showActivateModal}
            setShowActivateModal={setShowActivateModal}
            setActive={setActive}
          />
        )}
        <div className="report_head_wrap">
          <div
            className="report_head_left"
            onClick={() => history.push(`/app/stores`)}
          >
            <div className="report_heading">
              <img className="back_ico" src={BackIco} alt="" />{" "}
              <span className="main_head_txt">{storeDetails?.name}</span>{" "}
              {/* <span
                className={`status-badge ${active ? "active" : "inactive"}`}
              >
                {active ? "Active" : "Inactive"}
              </span> */}
            </div>
          </div>

          <div className="report_head_right">
            <AccountStatus
              active={active}
              onSuspendClick={handleSuspendClick}
              onActivateClick={handleActivateClick}
            />
            {/* {active ? (
              <button className="red_cta" onClick={handleSuspendClick}>
                <img src={SuspendIco} alt="" />
                Suspend Store
              </button>
            ) : (
              <button className="green_cta" onClick={handleActivateClick}>
                <img src={SuspendIco} alt="" />
                Activate Store
              </button>
            )} */}
            <button
              className="edit-store-btn"
              type="button"
              onClick={() => history.push(`/app/stores/${storeId}/edit`)}
            >
              <svg
                className="edit-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="m18.5 2.5 3 3L12 15l-4 1 1-4 9.5-9.5z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="button-text">Edit store</span>
            </button>
          </div>
        </div>
        {/* <div className="report_head_wrap">
          <div
            className="report_head_left"
            onClick={() => history.push(`/app/stores`)}
          >
            <div className="report_heading">
              <img className="back_ico" src={BackIco} alt="" />{" "}
              <span className="main_head_txt">{storeDetails?.name}</span>{" "}
            </div>
          </div>
          {storeDetails?.isActive && (
            <div className="report_head_right">
              {" "}
              <button
                className="red_cta"
                onClick={() => {
                  toggleStoreAction({
                    pageProps,
                    payload: "CLEAR",
                    action: "suspend",
                  });
                  setShowSuspendModal(true);
                }}
              >
                <img src={SuspendIco} alt="" />
                Suspend Store
              </button>
            </div>
          )}
        </div> */}
        <div className="top_chart_section">
          <div className="store_details_chart_wrap">
            {pageProps.getStoreDetailsRequest.request_status ===
              appConstants.GET_STORE_DETAILS_PENDING && <LoadingItem />}
            {pageProps.getStoreDetailsRequest.request_status ===
              appConstants.GET_STORE_DETAILS_SUCCESS && (
              <MetricsCards storeId={storeDetails.id} />
            )}
            {pageProps.getStoreDetailsRequest.request_status ===
              appConstants.GET_STORE_DETAILS_FAILURE && (
              <div className="all_graphs">
                <AlertMsg
                  type="error"
                  message={pageProps.getStoreDetailsRequest?.request_data.error}
                />
              </div>
            )}
          </div>
          <div className="store_details_chart_wrap second ">
            {pageProps.getStoreDetailsRequest.request_status ===
              appConstants.GET_STORE_DETAILS_PENDING && <LoadingItem />}
            {pageProps.getStoreDetailsRequest.request_status ===
              appConstants.GET_STORE_DETAILS_SUCCESS && (
              <StoreOwnerCard ownerData={storeDetails} />
            )}
            {pageProps.getStoreDetailsRequest.request_status ===
              appConstants.GET_STORE_DETAILS_FAILURE && (
              <div className="all_graphs">
                <AlertMsg
                  type="error"
                  message={pageProps.getStoreDetailsRequest?.request_data.error}
                />
              </div>
            )}
            {/* <div className="vendor_info_wrap">
            <div className="info_wrap">
              <div className="each_vendor_info">
                <div className="vendor_info_head">Store Owner</div>
                <div className="vendor_info_txt">
                  {storeDetails?.storeOwner}
                </div>
              </div>
              <div className="each_vendor_info">
                <div className="vendor_info_head">Contact number</div>
                <div className="vendor_info_txt">
                  {storeDetails?.phoneNumber}
                </div>
              </div>
            </div>
            <div className="each_vendor_info">
              <div className="vendor_info_head">Email</div>
              <div className="vendor_info_txt">{storeDetails?.email}</div>
            </div>
            <div className="each_vendor_info">
              <div className="vendor_info_head">Address</div>
              <div className="vendor_info_txt">{storeDetails?.address}</div>
            </div>
            <div className="info_wrap">
              <div className="each_vendor_info">
                <div className="vendor_info_head">Total sales</div>
                <div className="vendor_info_txt with_green">
                  ${storeDetails?.totalSales}
                </div>
              </div>
              <div className="each_vendor_info">
                <div className="vendor_info_head">
                  {storeDetails?.totalProducts > 0
                    ? "Number of products"
                    : "Products"}
                </div>
                {storeDetails?.totalProducts > 0 && (
                  <div className="vendor_info_txt with_green">
                    <span className="unset_txt">
                      {storeDetails?.totalProducts} -
                    </span>
                    <Link
                      state={{
                        storeData: { storeName: storeDetails?.name, storeId },
                      }}
                      className="page-Link"
                      to={`/app/stores/${storeId}/products`}
                    >
                      View Products
                    </Link>
                  </div>
                )}
                {storeDetails?.totalProducts === 0 && (
                  <div className="vendor_info_txt with_green">
                    <Link
                      state={{
                        storeData: { storeName: storeDetails?.name, storeId },
                      }}
                      className="page-Link"
                      to={`/app/stores/${storeId}/products/create-new`}
                    >
                      Create A Product
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div> */}
          </div>
        </div>
        <div className="bottom_chart_section charts_flex_row">
          <div className="store_chart_wrap">
            {pageProps.getStoreChartRequest.request_status ===
              appConstants.GET_A_STORE_CHART_PENDING && <LoadingItem />}
            {pageProps.getStoreChartRequest.request_status ===
              appConstants.GET_A_STORE_CHART_SUCCESS && (
              <div className="all-sale-stats cards">
                <div className="stats-heading">
                  <div className="heading-txt">Sales Report</div>
                  <div className="stats-heading">
                    <div
                      className={
                        salesFlag === 1
                          ? "each-stat-head  active"
                          : "each-stat-head"
                      }
                      onClick={() => setSalesFlag(1)}
                    >
                      6 Months
                    </div>
                    <div
                      className={
                        salesFlag === 2
                          ? "each-stat-head  active"
                          : "each-stat-head"
                      }
                      onClick={() => setSalesFlag(2)}
                    >
                      30 Days
                    </div>
                    <div
                      className={
                        salesFlag === 3
                          ? "each-stat-head  active"
                          : "each-stat-head"
                      }
                      onClick={() => setSalesFlag(3)}
                    >
                      7 Days
                    </div>
                    {/* <div className="each-stat-head">30 days</div> */}
                  </div>

                  <div className="goto-store">
                    <Link to={`/app/stores/${storeId}/details`}>
                      <span>View full report</span>
                    </Link>

                    {/* <img src={ExportIco} alt="" /> */}
                    {/* <Link to={`/app/stores/${storeId}/details`}>
                      <span>
                        View Orders <img src={TrendUp} alt="" />{" "}
                      </span>
                    </Link> */}
                  </div>
                </div>
                <div className="allstats">
                  <div className="each-chartwrap" id="chart-sales">
                    <SalesChart
                      salesData={
                        pageProps.getStoreChartRequest?.request_data?.response
                      }
                    />
                  </div>
                </div>
              </div>
            )}
            {pageProps.getStoreChartRequest.request_status ===
              appConstants.GET_A_STORE_CHART_FAILURE && (
              <AlertMsg
                type="error"
                message={pageProps.getStoreChartRequest?.request_data.error}
              />
            )}
          </div>
          <div className="store_chart_wrap second">
            <div className="vendor_graphs">
              <div className="top_of_graph">
                <div className="left_side">
                  <img src={ShopIco} alt="" />
                  <div className="title_txt">Best Sellers</div>
                </div>
                <div className="right_side">
                  <select
                    name=""
                    id=""
                    value={timeRange}
                    onChange={(e) => {
                      setTimeRange(e.target.value);
                    }}
                  >
                    <option value="">Choose Time Range</option>
                    <option value="7 Days">7 days</option>
                    <option value="30 Days">30 days</option>
                    <option value="90 Days">90 days</option>
                    <option value="180 Days">180 days</option>
                    <option value="365 Days">1 year</option>
                  </select>
                </div>
              </div>
              <BestSellers />
              {/* Loading and error states */}
              {/* {pageProps?.getStoreDetails?.request_status ===
    appConstants.GET_TOPSTORES_PENDING && (
    <div className="best_sellers_list">
      <LoadingItem />
    </div>
    )}
    {pageProps.getStoreDetails.request_status ===
    appConstants.GET_TOPSTORES_FAILURE && (
    <div className="best_sellers_list">
      <AlertMsg
        type="error"
        message={pageProps.getStoresListRequest?.request_data.error}
      />
    </div>
    )} */}
            </div>
          </div>
        </div>
        {/* </div> */}
        {pageProps.getStoreTransactionsRequest.request_status ===
          appConstants.GET_STORE_PAYMENT_HISTORY_PENDING && <LoadingItem />}
        {pageProps.getStoreTransactionsRequest.request_status ===
          appConstants.GET_STORE_PAYMENT_HISTORY_SUCCESS && (
          <div className="reports_table">
            <div className="report_actions">
              <input
                type="text"
                className="search_table"
                placeholder="Type in a transaction ID"
              />
            </div>
            <TableComponent
              childComponent={<ReportTable />}
              // childComponent={<ReportTable reportData={pageProps.getStoreOrdersRequest.request_data.response} />}
            />
          </div>
        )}
        {pageProps.getStoreTransactionsRequest.request_status ===
          appConstants.GET_STORE_PAYMENT_HISTORY_FAILURE && (
          <AlertMsg
            type="error"
            message={pageProps.getStoreTransactionsRequest?.request_data.error}
          />
        )}
      </div>
    );
  };

  // console.log("getDashbardBottompDataRequest", getDashbardBottompDataRequest);
  return (
    <div className="inapp-content">
      <div className="page-content dashboard">
        {pageProps.getStoreDetailsRequest.request_status ===
          appConstants.GET_STORE_DETAILS_PENDING && <LoadingItem />}
        {pageProps.getStoreDetailsRequest.request_status ===
          appConstants.GET_STORE_DETAILS_SUCCESS && <ReportsDisplay />}
        {pageProps.getStoreDetailsRequest.request_status ===
          appConstants.GET_STORE_DETAILS_FAILURE && (
          <AlertMsg
            type="error"
            message={pageProps.getStoreDetailsRequest?.request_data.error}
          />
        )}
      </div>
    </div>
  );
};

const StoreFullDetails = (pageProps: any) => {
  return (
    <InAppTemplate
      pageHeadingTitle="Vendor Management"
      childComponent={<InAppContent pageProps={pageProps} />}
    />
  );
};

const mapDispatchToProps = {
  getStoreDetailsAction: appActions.GetStoreDetails,
  getStoreTransactionsAction: appActions.GetStoreTransactions,
  toggleStoreAction: appActions.ToggleStore,
  getAStoreChartData: appActions.GetAStoreChart,
};

const mapStateToProps = (state: any) => ({
  getStoreDetailsRequest: state.allInAppReducers.getStoreDetailsReducer,
  getStoreTransactionsRequest:
    state.allInAppReducers.getStoreTransactionsReducer,
  d: state.allInAppReducers.toggleStoreReducer,
  getStoreChartRequest: state.allInAppReducers.getStoreChartReducer,
});
export default connect(mapStateToProps, mapDispatchToProps)(StoreFullDetails);
